import { computed } from 'vue'
import { useLocale } from './useLocale'
import caseStudies from '../content/case-studies'

/** Live case studies (published and placeholder-free) and their labels, in the current language. */
export function useCaseStudies () {
  const { locale } = useLocale()

  return {
    studies: computed(() => caseStudies.localised(locale.value)),
    labels: computed(() => caseStudies.labels(locale.value)),
    page: computed(() => caseStudies.page(locale.value)),
    find: (slug) => caseStudies.find(slug, locale.value),
    seo: caseStudies.seo
  }
}
